import { gql } from '@apollo/client';

const GET_COMPANY_USAGE = gql`query getCompanyUsage($companyId: Int!, $year_month: DateTime) {
	companyAdminContext {
		subscriptions {
			getCompanyUsage(companyId: $companyId, year_month: $year_month) {
				historicData
				storageInfo{
					storageUsage
					storageDetails
					{
						siteId
						siteName
						usage
					}
				}
				ownUsers {
					company
					subscriptionLevel
					userId
					username
				}
				paymentLiableUsers {
					company
					subscriptionLevel
					userId
					username
					sitemembership{
						name
						siteId
						siteRole
						subscriptionLevel
					}
				}
			}
		}
	}
}
`;

export default GET_COMPANY_USAGE;